export default __webpack_public_path__ + "static/media/bench.eb8ae0b1.jpg";